import { useLocation } from "@reach/router"
import { useEffect } from "react"

import { useQueryClient } from "@trueskin-web/apis"
import * as amplitudeClient from "@trueskin-web/apis/src/amplitude"
import { saveJwt } from "@trueskin-web/services/src/auth"
import { getStorageKeys } from "@trueskin-web/services/src/storage"

const storageKeys = getStorageKeys()

export const StoreJwtFromUrl = () => {
  const { search, pathname } = useLocation()
  const queryClient = useQueryClient()

  useEffect(() => {
    const searchParams = new URLSearchParams(search)
    if (searchParams.has(storageKeys.AUTH_JWT)) {
      amplitudeClient.removeIdentifier()
      queryClient.clear()
      window.localStorage.clear()
      saveJwt(searchParams.get(storageKeys.AUTH_JWT))

      searchParams.delete(storageKeys.AUTH_JWT)
      const queryString = `${searchParams}` ? `?${searchParams}` : ""

      window.location.href = `${pathname}${queryString}`
    }
  }, [search])

  return null
}
